import Vue from 'vue';
import VueCookie from 'vue-cookie';
import VueResource from 'vue-resource';
import JElementUI from '@jdcloud/jelement-next';

import JElementBiz from '@jdcloud/jelement-biz';
import '@jdcloud/jelement-biz/dist/theme-default/index.css';
import bizEnLocale from '@jdcloud/jelement-biz/dist/locale/lang/en';
import bizCnLocale from '@jdcloud/jelement-biz/dist/locale/lang/zh-CN';
import VueI18n from 'vue-i18n';
import Vuelidate from 'vuelidate';
import axios from 'axios';
import _ from 'lodash';
import enLocale from '@jdcloud/jelement-next/lib/locale/lang/en';
import zhLocale from '@jdcloud/jelement-next/lib/locale/lang/zh-CN';
import ElementLocale from '@jdcloud/jelement-next/lib/locale'
import { fixFilterDropdown } from '@/components/common/JElementUIUtils';
import api from './axiosHandler/index';
import App from './App';
import filters from '@/lib/filters';
import utils from '../static/js/utils';
import menuChecker from './menuChecker';
import '../static/css/jd.css';
import './main.css';
import Pop from '@/lib/popHelper';
import router from './router';
import service from './service/service';
import store from './store/index';
import global_ from '@/lib/global';
import myZh from './lib/i18n-zh-CN';
import myEn from './lib/i18n-en-US';
import { I18nConstant } from './lib/i18n';
import { RegionConstant } from './common/Constants';

Vue.config.productionTip = false;

Vue.prototype.GLOBAL = global_;
Vue.prototype.$axios = axios;
Vue.prototype._ = _;
Vue.prototype.$Pop = Pop;


Vue.use(VueResource);
Vue.use(service);
Vue.use(Vuelidate);
Vue.use(api);
Vue.use(utils);
Vue.use(VueCookie);

Object.keys(filters).forEach((key) => {
  console.log('[main.js] apply custom filter: %s', key);
  Vue.filter(key, filters[key]);
});

// 初始化公共配置项
store.dispatch('global/init');

// 修正表头筛选菜单位置乱跳的问题
fixFilterDropdown(Vue, JElementUI);

// 修正公共菜单
menuChecker(router);
// 标签相关操作保护
const BUILD_ENV = process.env.BUILD_ENV;
console.log('BUILD_ENV');
console.log(BUILD_ENV);
console.log(process.env.BUILD_ENV);
let JElementBizConfig;
console.log(VueCookie.get('jdcloud_sitelang'), I18nConstant.CN);
if (BUILD_ENV === 'prod') {
  JElementBizConfig = {
    locale: VueCookie.get('jdcloud_sitelang') === I18nConstant.CN
      || VueCookie.get('jdcloud_sitelang') === null ? bizCnLocale : bizEnLocale,
  };
} else {
  JElementBizConfig = {
    locale: VueCookie.get('jdcloud_sitelang') === I18nConstant.CN
      || VueCookie.get('jdcloud_sitelang') === null ? bizCnLocale : bizEnLocale,
    env: 'stag'
  };
}
Vue.use(JElementBiz, JElementBizConfig);

if (BUILD_ENV === 'prod') {
  Vue.prototype.TagRegionID = RegionConstant.other;
} else {
  Vue.prototype.TagRegionID = RegionConstant.stag;
}
const messages = {
  en: {
    ...myEn,
    ...enLocale
  },
  zh: {
    ...myZh,
    ...zhLocale
  }
};

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: VueCookie.get('jdcloud_sitelang') || 'cn',
  fallbackLocale: 'zh',
  messages,
});

Vue.use(JElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});

ElementLocale.i18n((key, value) => i18n.t(key, value))

new Vue({ // eslint-disable-line no-new
  i18n,
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store
});



// WEBPACK FOOTER //
// ./src/main.js